import { render } from "./McAlerts.vue?vue&type=template&id=1bd0a55e&scoped=true"
import script from "./McAlerts.vue?vue&type=script&lang=js"
export * from "./McAlerts.vue?vue&type=script&lang=js"

import "./McAlerts.vue?vue&type=style&index=0&id=1bd0a55e&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd0a55e"]])

export default __exports__